// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"50654033","787":"8c2feb6c"}[chunkId] + ".chunk.js";
};